export enum IsAuthReferrer {
    ShoppingCart = 0,
    SiteHeader = 1,
}